import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  setItem(key: string, value: any): void {
    if (typeof window === 'undefined') {
      return null;
    }
    localStorage?.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    if (typeof window === 'undefined') {
      return null;
    }
    const item: any = localStorage?.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
